export const steps = ['site', 'vehicle', 'usage', 'recommend'];
